<template>
	<div class="modal-card" style="width: 100%">
		<div class="modal-card-head">
			<div class="modal-card-title">Terms And Conditions</div>
		</div>
		<div class="modal-card-body">
			<terms></terms>
		</div>
		<div class="modal-card-foot">
			<div>
				<b-button type="button" @click="$parent.close()">Close</b-button>
			</div>
		</div>
	</div>
</template>
<script>
	import terms from "@/components/user/about/terms.vue";
	export default {
		components: {
			terms
		}
	};
</script>